import {
  FnbOrderResponse,
  MenuResponse,
  OrderingType,
  PickupPreview,
} from '@/types/fnb'

/**
 * Local-only pickup scenarios, so the menu bar and checkout picker can be
 * exercised without a matching venue or the `PATCH fnb/order/<uid>` endpoint.
 *
 * Set `REACT_APP_MOCK_PICKUP` to a MOCK_SCENARIOS key and/or
 * `REACT_APP_MOCK_ORDERING_TYPE` in `.env.local`. Guarded on NODE_ENV too, so
 * a production build can never serve it.
 */
const isDev = process.env.NODE_ENV === 'development'

const MOCK_OPTIONS = [
  { ref: 'mock-bar-1', name: 'Stalls Bar' },
  { ref: 'mock-bar-2', name: 'Circle Bar' },
  { ref: 'mock-bar-3', name: 'Terrace Kiosk North Floor Rooftop' },
]

const MOCK_SCENARIOS: Record<string, PickupPreview> = {
  routed: {
    mode: 'routed',
    selectable: false,
    planned: MOCK_OPTIONS[1],
    options: [],
  },
  default: {
    mode: 'default',
    selectable: false,
    planned: MOCK_OPTIONS[0],
    options: [],
  },
  options: {
    mode: 'options',
    selectable: true,
    planned: null,
    options: MOCK_OPTIONS,
  },
  'options-single': {
    mode: 'options',
    selectable: true,
    planned: null,
    options: MOCK_OPTIONS.slice(0, 1),
  },
  'options-empty': {
    mode: 'options',
    selectable: true,
    planned: null,
    options: [],
  },
}

const mockMode = process.env.REACT_APP_MOCK_PICKUP
const mockScenario = isDev
  ? MOCK_SCENARIOS[mockMode === 'true' ? 'options' : (mockMode ?? '')]
  : undefined
const mockOrderingType = isDev
  ? (process.env.REACT_APP_MOCK_ORDERING_TYPE as OrderingType | undefined)
  : undefined

export const mockPickupEnabled = !!mockScenario

export const withMockPickup = (menu: MenuResponse): MenuResponse => {
  const pickup = mockScenario ?? menu.pickup
  return {
    ...menu,
    pickup:
      pickup && mockOrderingType
        ? { ...pickup, ordering_type: mockOrderingType }
        : pickup,
  }
}

/** Mirrors the real PATCH response: the order, re-pointed at the chosen ref. */
export const mockPickupPatch = (
  order: FnbOrderResponse | null,
  location_id: string,
): FnbOrderResponse => {
  const option = MOCK_OPTIONS.find((o) => o.ref === location_id)
  return {
    ...(order as FnbOrderResponse),
    location_id,
    location_name: option?.name ?? '',
  }
}
